// @flow strict
import type {UserDetails} from 'src/types/referrer-portal';

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {getUserFormInputFields} from 'src/utils/referrer-portal';
import {
  Button,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  CardFooter,
  SubTitleMedium,
} from '@spaced-out/ui-design-system/lib/components/index';
import ReferralDetailRow from 'src/components/referral-v2/table/referral-details-row.jsx';
import UploadProfile from 'src/components/referrer-portal/settings/profile/upload-profile-pic.jsx';
import css from 'src/components/referrer-portal/settings/settings.css';


const ViewProfile = ({
  onChangeEdit,
  userData,
}: {
  onChangeEdit: () => mixed,
  userData: UserDetails,
}): React.Node => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const USER_FORM_INPUT_FIELDS = getUserFormInputFields(t);
  return (
    <Card classNames={{wrapper: css.profileCard}}>
      <CardHeader>
        <SubTitleMedium>
          {t('Personal_Information', 'Personal Information')}
        </SubTitleMedium>
        <UploadProfile />
      </CardHeader>
      <CardContent className={css.detailsRow}>
        {USER_FORM_INPUT_FIELDS.map((field) => (
          <ReferralDetailRow
            key={field.label}
            label={field.label ?? ''}
            value={userData ? userData[field.key] : '-'}
          />
        ))}
        <ReferralDetailRow
          autoTruncate={false}
          label={t('Bio', 'Bio')}
          value={userData.bio}
        />
      </CardContent>
      <CardFooter>
        <CardActions>
          <Button iconRightName="pen-to-square" onClick={onChangeEdit}>
            {t('Edit_Details', 'Edit Details')}
          </Button>
        </CardActions>
      </CardFooter>
    </Card>
  );
};

export default ViewProfile;
